/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsDoubleRight: {
  name: 'chevrons-double-right';
  data: string;
} = {
  name: 'chevrons-double-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.707 7.293a1 1 0 0 0-1.414 1.414L9.586 12l-3.293 3.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4Zm6 0a1 1 0 1 0-1.414 1.414L15.586 12l-3.293 3.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4Z" fill="currentColor"/></svg>`,
};
